var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestLibraryIconCrono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18.5px",
    height: "20.5px",
    viewBox: "0 0 18.5 20.5",
    enableBackground: "new 0 0 18.5 20.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.75,11.75H16c0,2.006-0.811,3.812-2.124,5.127C12.562,18.189,10.754,19,8.75,19s-3.812-0.811-5.127-2.123 C2.311,15.562,1.5,13.756,1.5,11.75c0-2.004,0.811-3.812,2.123-5.127C4.938,5.311,6.746,4.501,8.75,4.5 c2.004,0.001,3.812,0.811,5.126,2.123C15.189,7.938,16,9.746,16,11.75H16.75h0.75C17.499,6.918,13.582,3.001,8.75,3 C3.917,3.001,0,6.918,0,11.75c0,4.834,3.918,8.75,8.75,8.75s8.75-3.916,8.75-8.75H16.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,7.75v4c0,0.414,0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75v-4C9.5,7.336,9.164,7,8.75,7S8,7.336,8,7.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75,1.5h4c0.414,0,0.75-0.336,0.75-0.75S11.164,0,10.75,0h-4C6.336,0,6,0.336,6,0.75S6.336,1.5,6.75,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.28,4.22l-2-2c-0.293-0.293-0.768-0.293-1.061,0s-0.293,0.768,0,1.061l0.47,0.47l-1.812,1.814 c-0.293,0.293-0.293,0.768,0,1.061s0.768,0.293,1.061,0L17.28,4.28c0.293-0.293,0.293-0.768,0-1.061l-1-1 c-0.293-0.293-0.768-0.293-1.061,0s-0.293,0.768,0,1.061l2,2c0.292,0.293,0.768,0.293,1.061,0S18.573,4.513,18.28,4.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestLibraryIconCrono);
export default __webpack_public_path__ + "static/media/TEST_LIBRARY_ICON_CRONO.1ad4f5ddf70c8f0a6c27654242b1fafb.svg";
export { ForwardRef as ReactComponent };